import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { FiscalDocumentStatus } from "../../../../fiscal-documents"
import { useServer } from "../../../../../services/server"
import { useHoardService } from "../../../services/hoardService"

export const useActions = (onCorrected?: () => Promise<void>) => {
    const { correctHoardPrice } = useHoardService()
    const { generateCreditNote } = useServer()

    const { closeModal } = useUIActions()

    const submitPriceCorrection = async (
        hoardId: string,
        productId: string,
        newPrice: number,
        emitNow = false
    ) => {
        Emitter.emit(Event.DB_SUBMIT, 'Corrigiendo el precio...')

        try {
            const result = await correctHoardPrice(hoardId, productId, newPrice)
            // La corrección ya quedó guardada: si la emisión falla, la NC sigue PENDING para reintentar desde Documentos.
            if (emitNow && result.adjustmentNote?.fiscalStatus === FiscalDocumentStatus.PENDING) {
                try {
                    await generateCreditNote(result.adjustmentNote.id)
                } catch (error) {
                    showErrorStrToast(`La corrección se guardó, pero la NC #${result.adjustmentNote.code} quedó pendiente de emitir: ${error instanceof Error ? error.message : 'no se pudo emitir.'}`)
                }
            }
            onCorrected && await onCorrected()
            Emitter.emit(Event.DB_SUBMIT_DONE, false, false)
            closeModal(ModalId.CORRECT_HOARD_PRICE)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            // Con la factura en vuelo no hay nada que reintentar acá: se cierra para no dejar el modal trabado.
            closeModal(ModalId.CORRECT_HOARD_PRICE)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo corregir el precio.')
        }
    }

    return {
        submitPriceCorrection
    }
}
